export const NEWSLETTER_SUBSCRIPTION_ERR_MSG = {
  ALREADY_SUBSCRIBED_ANONYMOUS:
    '이미 구독 중인 이메일입니다. 다른 이메일을 입력해 주세요.',
  ALREADY_SUBSCRIBED_USER:
    '이미 뉴스레터를 구독 중입니다.\n로그인 후 [알림 설정] 내 수신 여부를 설정하세요.',
  NEED_SUBSCRIBED_USER:
    '뉴스레터 구독이 꺼져있습니다.\n로그인 후 [알림 설정]에서 구독을 켜주세요.',
  NEED_YOZMIT_PROFILE:
    '로그인 후 요즘IT 서비스를 시작해 주세요.\n뉴스레터를 구독할 수 있습니다.',
  NEED_CONTACT:
    '에러가 발생했습니다.\n위시켓 고객센터(02-6925-4849)로 연락해 주세요.',
  DEFAULT: '잠시 후 다시 시도해 주세요.',
};
